export const cities = [
  '전체', //1st section
  '서울',
  '부산',
  '대구',
  '인천',
  '광주',
  '대전',
  '울산',
  '세종',
  '충남', //2nd section
  '충북',
  '강원',
  '경기',
  '경북',
  '경남',
  '전북',
  '전남',
  '제주',
];

export const cityToCode = {
  서울: 1,
  부산: 6,
  대구: 4,
  인천: 2,
  광주: 5,
  대전: 3,
  울산: 7,
  세종: 8,
  충남: 34,
  충북: 33,
  강원: 32,
  경기: 31,
  경북: 35,
  경남: 36,
  전북: 37,
  전남: 38,
  제주: 39,
};
